import FileAttachmentsGraphQL from './FileAttachmentsGraphQL'

export default FileAttachmentsGraphQL
// eslint-disable-next-line import/export
export * from './FileAttachmentsGraphQL'
